import { AddIcon, PrimaryButton } from '@systemeio/ui'
import { Dispatch, SetStateAction, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export interface AddLectureButtonProps {
  onClick: (setFetching: Dispatch<SetStateAction<boolean>>) => void
}

export const AddLectureButton = ({ onClick }: AddLectureButtonProps) => {
  const { t } = useLocoTranslation()
  const [fetching, setFetching] = useState(false)

  return (
    <PrimaryButton
      onClick={() => {
        onClick(setFetching)
      }}
      isFetching={fetching}
      data-test={'module-create-lecture'}
    >
      <AddIcon />
      <span>{t('dashboard.course.add_lecture_modal.trigger_title')}</span>
    </PrimaryButton>
  )
}
